<div class="dialog-wrapper theme-interface" [ngClass]="customClass">
  <div class="top-dialog-content">
    <div class="dialog-close" *ngIf="!hideCloseButton">
      <span class="close-button" (click)="onCloseClick()">
        <span>{{ 'admin.store.close' | translate }}</span>
        <app-icon icon="fas fa-times"></app-icon>
      </span>
    </div>
    <h1
      *ngIf="dialogTitle"
      class="primary-brand-color col-lg-12 font-size-popup-title"
      mat-dialog-title
    >
      {{ dialogTitle }}
    </h1>
  </div>
  <ng-content></ng-content>
</div>
